module.exports = __webpack_public_path__ + "99723b7e2e04dccd852c6d739dc2496d.pdf";